// ---- NEW: Blob Items Viewer types ----
export type BlobViewerItemType = 'image' | 'pdf' | 'dicom' | 'audio' | 'video';

export interface BlobViewerItem {
  /** A browser blob URL (blob:...) or any direct URL that doesn't require auth */
  url: string;
  /** Media type — drives which sub-viewer is rendered */
  type: BlobViewerItemType;
  /** Optional display name (used for download filename, PDF title, etc.) */
  name?: string;
}
// ---- END NEW ----

export interface ImageViewerConfig {
  btnClass?: string;
  zoomFactor?: number;
  containerBackgroundColor?: string;
  wheelZoom?: boolean;
  allowFullscreen?: boolean;
  allowKeyboardNavigation?: boolean;
  allowDownload?: boolean;

  btnShow?: {
    zoomIn?: boolean;
    zoomOut?: boolean;
    rotateClockwise?: boolean;
    rotateCounterClockwise?: boolean;
    next?: boolean;
    prev?: boolean;
  };

  btnIcons?: {
    zoomIn?: string;
    zoomOut?: string;
    rotateClockwise?: string;
    rotateCounterClockwise?: string;
    next?: string;
    prev?: string;
    fullscreen?: string;
    download?: string;
  };

  customBtns?: Array<
    {
      name: string;
      icon: string;
    }
  >;
}

export class CustomEvent {
  name: string;
  imageIndex: number;

  constructor(name, imageIndex) {
    this.name = name;
    this.imageIndex = imageIndex;
  }
}
